import { WifiOff, CircleX, Package, Bug } from 'lucide-react';
import { ErrorType } from './errorTypes';
import { BusinessErrorResponse } from '@/queries/api-client';

interface ErrorAction {
  text: string;
  onClick: () => void;
}

export interface ErrorConfig {
  icon: React.ReactNode;
  title: string;
  description: string;
  primaryAction: ErrorAction;
  secondaryAction?: ErrorAction;
}

export function getErrorConfig(type: ErrorType, error: unknown): ErrorConfig {
  console.log(error);
  const commonSecondaryAction = {
    text: 'Report Issue',
    onClick: () => {
      // TODO: open intercom & email
    },
  };

  const configs: Record<ErrorType, (error: unknown) => ErrorConfig> = {
    [ErrorType.NETWORK]: () => ({
      icon: <WifiOff className="h-10 w-10 text-red-600" />,
      title: 'Network Connection Failed',
      description:
        'Unable to connect to the server. Please check your internet connection and try again.',
      primaryAction: {
        text: 'Reload Page and Try Again',
        onClick: () => window.location.reload(),
      },
      secondaryAction: commonSecondaryAction,
    }),

    [ErrorType.SERVER_API]: error => ({
      icon: <CircleX className="h-10 w-10 text-red-600" />,
      title: 'Request Failed',
      description:
        (error as BusinessErrorResponse).message ||
        'The server encountered an error while processing your request.',
      primaryAction: {
        text: 'Try Again',
        onClick: () => window.location.reload(),
      },
    }),

    [ErrorType.CHUNK_LOAD]: () => ({
      icon: <Package className="h-10 w-10 text-red-600" />,
      title: 'Failed to Load Content',
      description:
        'The required content failed to load. This might be due to network issues or outdated cache.',
      primaryAction: {
        text: 'Reload Page and Try Again',
        onClick: () => window.location.reload(),
      },
      secondaryAction: commonSecondaryAction,
    }),

    [ErrorType.RUNTIME]: error => ({
      icon: <Bug className="h-10 w-10 text-red-600" />,
      title: 'Something Went Wrong',
      description:
        error instanceof Error
          ? error.message
          : 'An unexpected error occurred while processing your request.',
      primaryAction: {
        text: 'Reload Page and Try Again',
        onClick: () => window.location.reload(),
      },
      secondaryAction: commonSecondaryAction,
    }),
  };

  return configs[type](error);
}
